export const namespace = "namespace:admin";
